import { useState } from 'react';
import { adminApi } from '../api/adminClient';

export default function InviteOperatorModal({
  onClose,
  onCreated,
}: {
  onClose: () => void;
  onCreated: () => void;
}) {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setErr(null);
    try {
      await adminApi.createOperator(email);
      onCreated();
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Invitar operador</h3>
        <p className="opacity-70 text-sm mb-4">
          Crea un acceso de operador para un correo externo. Si aún no se ha registrado, obtendrá acceso al iniciar sesión por primera vez.
        </p>
        <input
          className="input input-bordered w-full"
          placeholder="email@dominio.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {err && <div className="alert alert-error mt-2">{err}</div>}
        <div className="modal-action">
          <button className="btn btn-ghost" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={submit} disabled={busy || !email}>
            Crear
          </button>
        </div>
      </div>
    </div>
  );
}
